// https://app.growthbook.io/features/prcng-1194_v1
export const MC_PRO_TIER_FLAG_NAME = 'prcng-1194_v1'

export type MCProBucket = 'control' | 'variant_1' | 'variant_2' | 'variant_3'
